import { checklistApi } from '@/services/checklistApi'
const qs = require('qs')

export function listCompanies(params = {}) {
  return checklistApi.get('/admin/company/list', {
    params,
    paramsSerializer: (p) => qs.stringify(p, { arrayFormat: 'repeat' }),
  })
}
